angular
  .module('customer')

  .directive('customerSummary', [
    '$filter',
    function($filter) {
      'use strict';

      return {
        restrict: 'E',
        replace: true,
        scope: true,
        templateUrl: 'custom/customer/views/partials/customerSummary.html',
        controller: [
          '$scope',
          '$state',
          'CustomerStore',
          'LoggedUser',
          function($scope, $state, CustomerStore, LoggedUser) {
            $scope.active = false;
            $scope.customer = {};
            $scope.headquarter = {};
            $scope.isPM = LoggedUser.isPM();

            CustomerStore.listenTo(function(customer) {
              $scope.active = customer ? !!customer.active : false;
              $scope.customer = angular.copy(customer || {});
              $scope.headquarter = $scope.customer.headquarter;
              $scope.lastZohoSync = customer.lastZohoSync;
            });

            $scope.goToTasksPm = () => {
              const { _id, company } = $scope.customer || {};
              let { first_name, last_name } = $scope.customer || {};
              first_name = first_name || '';
              last_name = last_name || '';
              const { _id: companyId, company_name } = company || {};
              const areParamsValid =
                _id && companyId && company_name && (first_name || last_name);

              areParamsValid &&
                $state.go('root.app.simple.tasksPm', {
                  company: { _id: companyId, name: company_name },
                  customer: { _id, first_name, last_name }
                });
            };
          }
        ]
      };
    }
  ]);
